import { Components } from '@mui/material'
import MuiButton from './MuiButton'
import MuiIconButton from './MuiIconButton'
import MuiFormComponents from './MuiFormComponents'
import MuiSurfaces from './MuiSurfaces'

const themeComponents: Components = {
  MuiButton,
  MuiIconButton,
  ...MuiFormComponents,
  ...MuiSurfaces,
}

export default themeComponents
